import React, { useEffect, useState } from 'react'
import { Button, Container, Form } from 'react-bootstrap';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { useAnalytics } from '../hooks/use-analytics'

interface SearchPopupProps {
    visible: boolean;
    handleVisibility: () => void;
}

export const SearchPopup = (props: SearchPopupProps) => {

    const { visible, handleVisibility } = props;
    const { trackSearch } = useAnalytics();

    const [searchValue, setSearcValue] = useState<string>('');

    const handleSearchSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (searchValue.trim()) {
            // Track the search - you can add results count if available
            trackSearch(searchValue.trim());
            // Add your search logic here
        }
    }

    useEffect(() => {
        const handlePopupClick = (e: MouseEvent) => {
          const target = e.target as HTMLElement;
          
          if (
            target.closest('.search-popup-close') || 
            target.closest('.search-popup-close svg') ||
            target.closest('.search-popup-close path') ||
            target.classList.contains('search-popup')
          ) {
            e.preventDefault();
            handleVisibility();
          }
        };
    
        const handleKeyUp = (e: KeyboardEvent) => {
          if (e.key === 'Escape') {
            handleVisibility();
          }
        };
    
        const popup = (document.querySelector('.search-popup') as HTMLElement);

        if (!popup) return ;

        popup.addEventListener('click', handlePopupClick);
        document.addEventListener('keyup', handleKeyUp);
    
        return () => {
          popup?.removeEventListener('click', handlePopupClick);
          document.removeEventListener('keyup', handleKeyUp);
        };
    }, [handleVisibility]);
    

    return (
        <Container as='div' bsPrefix='search-cont' className={`search-popup ${visible ? 'is-visible' : ''}`}>
            <div className="search-popup-container">

                <Form role="search" onSubmit={handleSearchSubmit} method="GET" className="form-group" action="">
                    <Form.Control 
                        type="search" 
                        id="search-form" 
                        className="form-control border-0 border-bottom"
                        placeholder="Type and press enter" 
                        autoFocus
                        value={searchValue}
                        name="search" 
                        onChange={(e) => setSearcValue(e.target.value)}
                    />
                    <Button 
                        type="submit" 
                        className="search-submit border-0 position-absolute bg-white"
                        style={{
                            top: '15px',
                            right: '15px'
                        }}
                    >
                       <MagnifyingGlassIcon width={25} height={25} color='#333' />         
                    </Button>
                </Form>

                <h5 className="cat-list-title">Browse Result</h5>

                {/* <ul className="cat-list">
                    <li className="cat-list-item">
                        <a href="#" title="Jackets">Jackets</a>
                    </li>
                </ul> */}

            </div>

        </Container>
    )
}
